var render, staticRenderFns
import script from "./stores_resources.vue?vue&type=script&lang=js"
export * from "./stores_resources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba782982')) {
      api.createRecord('ba782982', component.options)
    } else {
      api.reload('ba782982', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/execute/stores_resources/stores_resources.vue"
export default component.exports